/**
 * WhatsApp template-variable helpers (web copy).
 *
 * SOURCE OF TRUTH: `packages/channels/src/utils/template-vars.ts` (plan §0.E).
 * These two pure functions are duplicated here intentionally rather than
 * adding `@kc3/channels` (a heavy server-side package depending on @kc3/db,
 * drizzle-orm, etc., with no exports map) as a frontend dependency. The
 * count + render semantics MUST stay identical to the channels package; if
 * the regex/behaviour changes there, mirror it here.
 */
const VAR_REGEX = /\{\{(\d+)\}\}/g

/**
 * Count the number of distinct variables a template expects (max 1-based
 * index referenced; handles non-contiguous indices).
 */
export function countTemplateVariables(bodyText: string): number {
  let max = 0
  for (const m of bodyText.matchAll(VAR_REGEX)) {
    max = Math.max(max, Number(m[1]))
  }
  return max
}

/**
 * Render a template body by substituting `{{n}}` with `variables[n-1]`.
 * Missing variables leave the original `{{n}}` placeholder in place.
 */
export function renderTemplate(bodyText: string, variables: string[]): string {
  return bodyText.replace(VAR_REGEX, (_, n) => variables[Number(n) - 1] ?? `{{${n}}}`)
}
